import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c76f3e9c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c76f3e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76f3e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c76f3e9c')) {
      api.createRecord('c76f3e9c', component.options)
    } else {
      api.reload('c76f3e9c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c76f3e9c&scoped=true&", function () {
      api.rerender('c76f3e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xEawGlC2bVJ3/JS/comp/GuestBox.vue"
export default component.exports